export const getCourseLink = (matcher, key) => {
	return matcher?.[key] ?? null;
};